import React from 'react'
import BudgetTransactions from 'src/app/BudgetTransactions/BudgetTransactions'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetTransactionsRouteProps } from 'src/navigation/routeProps'

const BudgetTransactionsAppRoute: AppRoute = {
  id: AppLocation.BudgetTransactions,
  routeProps: budgetTransactionsRouteProps,
  component: <BudgetTransactions />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetTransactionsAppRoute
